import { computed
       , observable
       , toJS }                   from 'mobx'

import { API
       , kde_api_pseudo_job_t
       , kde_api_mastering_t }     from '../02_api'
import { CRUD
       , FACTORY
       }                          from '../09_model_app'

let g_workgroups: MKeyMastering ;

export class MKeyMastering
{
  @observable public _selected_mastering_id: number | null = null ;
  @observable public selected_tasks: string[] = [] ;
  @observable public num_keys: Map< number, number > = new Map( ) ;

  data = new CRUD<kde_api_mastering_t>(
      user => API.KEY_MASTERING( user? user.workgroup!.cloud.id : 0 )
    , user =>
       FACTORY.KEY_MASTERING.data_fetcher_for( { cloud_id: user? user.workgroup!.cloud.id : 0 } )
    ) ;

  get_num_keys = ( job_id: number ) =>
  {
    if ( this.num_keys.has( job_id ) )
         return this.num_keys.get( job_id )! ;

    const tasks = this.pseudo_tasks ;

    if ( !tasks )
         return 0 ;

    const pseudo_job = tasks.find( t => t.id === job_id ) ;

    return pseudo_job? pseudo_job.quantity : 0 ;
  }

  set_num_keys ( job_id: number, num: number )
  {
    this.num_keys.set( job_id, num ) ;
  }

  total_num_keys ( )
  {
    const num_keys: number[] = this.selected_tasks.map( job_id => this.get_num_keys( parseInt( job_id, 10 ) ) ) ;

    return num_keys.reduce( (a:number, b:number) => a + b, 0 ) ;
  }


  bulk ( )
  {
    const tasks = this.pseudo_tasks ;

    if ( tasks === null )
         return [] ;

    const task_hash: Map<string, kde_api_pseudo_job_t> = new Map( ) ;

    tasks.forEach( t => task_hash.set( t.id.toString( ), t ) ) ;

    const ret: kde_api_pseudo_job_t[] = [] ;
    
    this.selected_tasks.forEach( job_id => 
    {
      if ( task_hash.has( job_id ) )
        {
           const { id, quantity, ...job_without_id } = toJS( task_hash.get( job_id )! ) ;

           ret.push( { ...job_without_id, quantity: this.get_num_keys( parseInt( job_id, 10 ) ) } as kde_api_pseudo_job_t ) ;
        }
    } ) ;

    return ret ;
  }


  @computed get masterings ( )
  {
    return this.data.data_for_page( 0 ) ;
  }

  @computed get pseudo_tasks ( )
  {
    const ret = this.mastering ;

    return ret? ret.mksJobs : null ;
  }

  @computed get mastering ( )
  {
    const masterings   = this.masterings.data
        , mastering_id = this.selected_mastering 

    if ( !masterings || mastering_id === null )
         return null ;
    
    return masterings.find( t => t.id === mastering_id ) ;
  }

  @computed get client_name ( )
  {
    const ret = this.mastering ;
    
    return ret? [ ret.client.name, ret.client.surnames ].join( ' ' ) : null ;
  }

  // @computed get workgroup_id ( )
  // {
  //   return this.selected_mastering? this.selected_mastering : 0 ;
  // }

  @computed get selected_mastering ( ) : number | null
  {
    const masterings = this.masterings ;

    return this._selected_mastering_id === null && !masterings.loading && masterings.data && masterings.data.length > 0?
           masterings.data[ 0 ].id
         : this._selected_mastering_id ;
  }


  set selected_mastering ( value: number | null )
  {
    this.reset_selected_tasks( ) ;
    this._selected_mastering_id = value ;
  }

  public reset_selected_tasks ( )
  {
    this.num_keys.clear( ) ;
    this.selected_tasks = [] ;
  }

  public static instance ( )
  {
    if ( !g_workgroups )
          g_workgroups = new MKeyMastering( ) ;

    return g_workgroups ;
  }
}
